export const THEME_BLUE = 'blue';
export const THEME_WHITE = 'white';
